import React from "react";
import { Grid, Typography, Paper } from "@mui/material";
import SectionWrapper from "./SectionWrapper";
import image from "../images/portrait.jpg";

const title = "Om mig";
const bread: string[] = [
  "Mitt namn är Bengt-Åke Nilsson.",
  "Jag är nystartad företagare baserad i Staffanstorp.",
  `Min affärsidé är att hjälpa företagare med enklare arbete. Det frigör tid för er så ni kan
  fokusera på er huvudsyssla.`,
  "Privatpersoner erbjuds tjänster inom trädgård och fastighet (rot-arbeten).",
  "Service av bilar och släp.",
  "Ansvarsförsäkring, ID 06 och F-skatt finns givetvis.",
];

const About: React.FC = () => {
  return (
    <SectionWrapper name="about" bg={undefined} minHeight="70vh">
      <Grid container spacing={{ xs: 2, sm: 4 }} justifyContent={"space-between"}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Paper elevation={3} sx={{ p: { xs: 2, sm: 3 } }}>
            <Typography variant="h3" component="div" gutterBottom sx={{ fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" } }}>
              {title}
            </Typography>
            <Typography variant="body1" sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
              <>
                {bread.map((line, i) => (
                  <div style={{ margin: "0.5rem 0" }} key={i}>
                    {line}
                  </div>
                ))}
              </>
            </Typography>
          </Paper>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <img
            src={image}
            alt="This is a closeup of the owner"
            style={{
              width: "100%",
              alignContent: "right",
              maxHeight: "60vh",
              objectFit: "cover",
            }}
          />
      </Grid>
      </Grid>
    </SectionWrapper>
  );
};

export default About;
